import * as STD from '@emersya/mpa-std';
import './index.scss';

declare global {
	interface Window {
		readonly MPAComponentsManager: {
			readonly DOMComponent: typeof _DOMComponent;
			readonly Component: typeof _Component;
			readonly Manifest: typeof _Manifest;
			readonly Path: typeof _Path;
			readonly Condition: typeof _Condition;
			readonly PropertyOperation: typeof _PropertyOperation;
			readonly Plugin: typeof _Plugin;
			readonly Manager: typeof _Manager;
		};
	}
}
(<STD.object.SetWritable<typeof window, 'MPAComponentsManager'>>window).MPAComponentsManager = {
	DOMComponent: _DOMComponent,
	Component: _Component,
	Manifest: _Manifest,
	Path: _Path,
	Condition: _Condition,
	PropertyOperation: _PropertyOperation,
	Plugin: _Plugin,
	Manager: _Manager
};
import _Manager from './Manager';
import _DOMComponent from './DOMComponent';
import _Component from './Component';
import _Manifest from './Manifest';
import _Path from './Path';
import _Condition from './Condition';
import _PropertyOperation from './PropertyOperation';
import _Plugin from './Plugin';

export {default as Manager} from './Manager';
export {default as DOMComponent} from './DOMComponent';
export {default as Component} from './Component';
export {default as Manifest} from './Manifest';
export {default as Path} from './Path';
export {default as Condition} from './Condition';
export {default as PropertyOperation} from './PropertyOperation';
export {default as Plugin} from './Plugin';

import './manifests/ManagerManifest';
import './manifests/ComponentManifest';